import { ColorGroupApi } from '@/types/Color';
import { ColorGroup as ColorGroupType } from '@/types/Color';
import { GraphicElement, GraphicElementApi } from '@/types/GraphicElement';
import { Engine } from '@/engine/core/Engine';
import { ColorGroup as EngineColorGroup } from '@/engine/entities/ColorGroup';
import { Color as EngineColor } from '@/engine/entities/Color';

export class GraphicElementMapper {
    static getGraphiElementFromEngineContent(graphicElementData: GraphicElementApi): GraphicElement {
        const { uuid, type, options } = graphicElementData;
        const graphicElement: GraphicElement = {
            uuid: uuid,
            type: type,
            key: uuid,
            content: this.getContentByType(graphicElementData),
            options: { ...options },
            angle: graphicElementData.angle,
            width: graphicElementData.size.width,
            height: graphicElementData.size.height,
            scaleX: graphicElementData.scale.scaleX * Engine.getInstance().canvas.width,
            scaleY: graphicElementData.scale.scaleY * Engine.getInstance().canvas.height
        };
        if (Array.isArray(graphicElementData.colorGroups)) {
            // Defensif : tolere les shapes {id, hexaValue} flat et les
            // colorGroups sans .color (BackPattern mal forme, data
            // partielle...). Filtre les entrees invalides au lieu de
            // throw — sinon Studio.findById casse et la page "Suivant"
            // plante au clic.
            graphicElement.colors = graphicElementData.colorGroups
                .map((colorGroup: any) => {
                    const hex =
                        colorGroup?.color?.hexaValue ??
                        colorGroup?.color?._hexaValue ??
                        colorGroup?.hexaValue ??
                        colorGroup?._hexaValue;
                    if (typeof hex !== 'string') {
                        return null;
                    }
                    return { hexaValue: hex, id: colorGroup.id };
                })
                .filter((c: any) => c !== null);
        }

        return graphicElement;
    }

    static getContentByType(element: GraphicElementApi) {
        const type = String(element.type ?? '').toLowerCase();
        if (type === 'text') {
            return element.content;
        } else if (['graduation', 'image', 'imagesvg'].includes(type)) {
            if (typeof element.content?.getContent === 'function') {
                return element.content.getContent();
            }
            return (element.content as any)?._actualContent ?? (element.content as any)?.value ?? element.content ?? '';
        } else if (type === 'backpattern') {
            return element.options?.patternPath;
        }
        return '';
    }

    static getColorGroupsFromData(colors: ColorGroupType[]): ColorGroupApi[] {
        const colorGroups: ColorGroupApi[] = [];
        colors.forEach((color) => {
            colorGroups.push(new EngineColorGroup(color.id, new EngineColor(color.hexaValue)));
        });

        return colorGroups;
    }
}
